const general = {
  all: 'Todos',
  apply: 'Aplicar',
  category: 'Categoría',
  categories: 'Categorías',
  custom: 'Personalizado',
  doors: 'Puertas',
  resetDate: 'Restablecer la fecha',
  resetFilters: 'Restablecer los filtros',
  users: 'Usuarios',
  legend: 'Leyenda',
  export: 'Exportar',
  export_all: 'Exportar todo',
  organizations: 'Cuentas',
  download_started: 'Descarga iniciada',
  delay: 'Retraso',
  entry_reader: 'Lector de entrada',
  exit_reader: 'Lector de salida',
  door: 'Puerta',
  schedule: 'Horario',
  user: 'Usuario',
  account: 'Cuenta',
  unassign: 'Desasignar',
  assigned: 'Asignado',
  unassigned: 'No asignado',
  unused_since: 'Sin uso desde',
  unused_since_options: {
    any: 'Cualquiera',
    last_month: 'Último mes',
    last_3_months: '3 meses',
    last_6_months: '6 meses',
    never: 'Nunca',
  },
  clear: 'Limpiar',
  access_levels: 'Niveles de acceso',
  activation: 'Activación',
  expiration: 'Expiración',
  credentials: 'Credenciales',
  dataLoadingFailed: 'Se produjo un error al cargar los datos.',
  role: 'Role',
  roles: 'Roles',
  failed: 'Fallido',
  inputs: 'Entradas',
  keypad_code: 'Código teclado',
  not_assigned: 'No asignado',
  pending: 'Pendiente',
  ping: 'Ping',
  contactYourDealer: 'Contacta a tu distribuidor',
  controller: 'Controlador',
  date_and_time: 'Fecha y hora',
  description: 'Descripción',
  details: 'Detalles',
  name: 'Nombre',
  object_type: 'Tipo de objeto',
  site: 'Sitio',
  sites_assigned: 'Sitios asignados',
  active: 'Activo',
  inactive: 'Inactivo',
  deactivate: 'Desactivar',
  yes: 'Si',
  no: 'No',
  boolean_none: 'Ninguno',
  boolean_false: 'Falso',
  boolean_true: 'Verdadero',
  day: 'Día',
  hour: 'Hora',
  minute: 'Minuto',
  the: 'La',
  yearly: 'Anual',
  on: 'En',
  and: 'Y',
  welcome: 'Bienvenido',
  online: 'En línea',
  offline: 'Sin conexión',
  all_sites: 'Todos los sitios',
  access_all_accounts: 'Acceso a todas las cuentas, incluidas las nuevas',
  refresh: 'Resfrescar',
  success: 'Éxito',
  error: 'Error',
  kprog_error: 'Error Kprog',
  delete_message: 'Estas seguro que deseas eliminar',
  are_you_sure: '¿Está seguro?',
  replacing: 'Reemplazando',
  rebooting: 'Reiniciando',
  from: 'De',
  to: 'Para',
  to_label: 'a',
  status_label: 'Estado:',
  general: 'General',
  confirmation: 'Confirmación',
  filters: 'Filtros',
  search: 'Buscar',
  results: 'Resultados',
  loading: 'Cargando',
  loading_ellipsis: 'Cargando...',
  reason: 'Razón',
  alerts: 'Alertas',
  multisite: 'Multisitio',
  comments: 'Comentarios',
  leave_message:
    '¿Estás seguro de que quieres salir? Se perderán los cambios no guardados.',
  quantity: 'Cantidad',
  status: 'Estado',
  summary: 'Resumen',
  general_information: 'Información general',
  activate: 'Activar',
  events: 'Eventos',
  save: 'Guardar',
  enabled: 'Habilitado',
  today: 'Hoy',
  yesterday: 'Ayer',
  launch: 'Lanzar',
  enable: 'Habilitar',
  finished: 'Hecho',
  settings: 'Configuraciones',
  more_filters: 'Mas filtros',
  radio_options: 'Opciones de radio',
  invalid_date: 'Fecha inválida',
  field_required: 'Este campo es obligatorio',
  date_after: 'La fecha debe ser en o después de {{date}}',
  date_before: 'La fecha debe ser en o antes de {{date}}',
  date_from_before_to: 'La fecha de inicio debe ser anterior a la fecha de fin',
  date_to_after_from: 'La fecha de fin debe ser posterior a la fecha de inicio',
  date_from_too_late: 'Debe ser anterior o igual a la fecha de fin',
  date_to_too_early: 'Debe ser posterior o igual a la fecha de inicio',
  file_too_big:
    'El tamaño del archivo es muy grande. Seleccione un archivo más pequeño que 1 MB',
  state: 'Estado',
  back_to_list: 'Volver a la lista',
  company: 'Compañía',
  country: 'País',
  city: 'Ciudad',
  phone: 'Teléfono',
  address: 'Dirección',
  none: 'Ninguno',
  no_image: 'Sin imagen',
  unknown: 'Desconocido',
  object: 'Objeto',
  type: 'Tipo',
  id: 'ID',
  display_name: 'Nombre para mostrar',
  serial_number: 'Número de serie',
  format: 'Formato',
  formats: 'Formatos',
  site_name: 'Nombre del sitio',
  replace: 'Reemplazar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  profile: 'Perfil',
  province_territory: 'Provincia o Territorio',
  zip_code: 'Código postal',
  postal_code: 'Código postal',
  email: 'Correo electrónico',
  first_name: 'Nombre',
  last_name: 'Apellido',
  full_name: 'Nombre completo',
  start: 'Iniciar',
  stop: 'Detener',
  purchase: 'Compra',
  date: 'Fecha',
  title: 'Título',
  event: 'Evento',
  btn: {
    buy: 'Comprar',
    discontinue: 'Discontinuar',
    continue: 'Continuar',
    back: 'Retroceder',
    open: 'Abrir',
    select: 'Seleccionar',
    view: 'Vista',
    delete: 'Borrar',
    update: 'Actualizar',
    edit: 'Editar',
    submit: 'Enviar',
    confirm: 'Confirmar',
    next: 'Próximo',
    previous: 'Anterior',
    checkout: 'Verificar',
    add_card: 'Agregar',
    dismiss: 'Descartar',
    add_user: 'Agregar',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    enable_access: 'Habilitar acceso',
    disable_access: 'Deshabilitar acceso',
    done: 'Hecho',
    remove: 'Remover',
    reset: 'Reiniciar al estado normal',
    lock: 'Cerrar (anular)',
    unlock: 'Desbloquear (anular)',
    grant_access: 'Autorizará el acceso',
    grant_extend: 'Extender Accesso',
    actions: 'Acciones',
    disabled: 'Deshabilitado',
    register: 'Registrar',
    refresh: 'Refrescar',
    restore: 'Restaurar',
    send: 'Enviar',
    test: 'Prueba',
    list_view: 'Vista de lista',
    chart_view: 'Vista de gráfico',
    default: 'Defecto',
    go_back: 'Regresar',
    now: 'Ahora',
    later: 'Más tarde',
    resend: 'Reenviar',
    add: 'Agregar',
    ok: 'OK',
    apply: 'Aplicar',
  },
  form: {
    timezone: 'Zona horaria',
  },
  month: {
    january: 'Enero',
    february: 'Febrero',
    march: 'Marzo',
    april: 'Abril',
    may: 'Mayo',
    june: 'Junio',
    july: 'Julio',
    august: 'Agosto',
    september: 'Septiembre',
    october: 'Octubre',
    november: 'Noviembre',
    december: 'Diciembre',
  },
  day_name: {
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
  },
  cardinal: {
    first: 'Primero',
    second: 'Segundo',
    third: 'Tercero',
    fourth: 'Cuarto',
    last: 'Último',
  },
  aria_expand_row: 'Expandir fila',
  aria_breadcrumb: 'Ruta de navegación',
  aria_choices: 'Opciones',
  aria_options: 'Opciones',
  options_label: 'Opciones',
  options_label_2: 'Opciones 2',
  checkbox_options_label: 'Opciones de casilla',
  status_ok: 'Estado: OK',
  error_fallback_title: '¡Ups! Algo salió mal.',
  error_fallback_message:
    'El problema se ha notificado a nuestro equipo y se resolverá lo antes posible. Gracias por su paciencia.',
  event_id: 'ID del evento',
  error_selecting_image: 'Error al seleccionar el archivo de imagen',
  date_filter: {
    all: 'Todos',
    this_week: 'Esta semana',
    last_week: 'La semana pasada',
    this_month: 'Este mes',
    last_month: 'El mes pasado',
    this_year: 'Este año',
    last_7_days: 'Últimos 7 días',
    last_30_days: 'Últimos 30 días',
    last_60_days: 'Últimos 60 días',
    last_90_days: 'Últimos 90 días',
    last_180_days: 'Últimos 180 días',
    custom: 'Personalizado',
    range: 'Desde {{ from }} hasta {{ to }}',
    from: 'Desde {{ from }}',
    to: 'Hasta {{ to }}',
  },
};

export default general;
